import { defineComponent as _defineComponent } from 'vue'
import { ref, unref } from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Dropdown',
  setup(__props, { expose }) {

    const opened = ref(false);

    const close = () => {
        opened.value = false;
    };

    const open = () => {
        opened.value = true;
    };

    expose({
        toggle: () => (unref(opened) ? close() : open()),
        close: () => close(),
        open: () => open(),
    });

return { __sfc: true,opened, close, open }
}

})